import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgCollaborationIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.2}
      d="M23.11 11.33 16.5 7.51a1 1 0 0 0-1 0l-6.61 3.82a1 1 0 0 0-.5.87v7.64a1 1 0 0 0 .5.86l6.61 3.82a1 1 0 0 0 1 0l6.61-3.82a1 1 0 0 0 .5-.86V12.2a1 1 0 0 0-.5-.87Zm-1.5 7.93L16 22.5l-5.61-3.24v-6.48L16 9.54l5.61 3.24zM16 1.94a1.79 1.79 0 0 1 0 3.57 1.79 1.79 0 0 1 0-3.57Zm0 28.12a1.79 1.79 0 0 1 0-3.57 1.79 1.79 0 0 1 0 3.57ZM25.48 8a1.79 1.79 0 0 1 1.89 3 1.79 1.79 0 0 1-1.89-3Zm-19 16a1.79 1.79 0 0 1-1.89-3 1.79 1.79 0 0 1 1.93 3zM4.84 10.59a1.803 1.803 0 1 1 2-3 1.803 1.803 0 0 1-2 3Zm20.32 13.78a1.803 1.803 0 1 1 2.001-3.001 1.803 1.803 0 0 1-2.001 3Z"
    />
  </svg>
);
export default SvgCollaborationIcon;
